/**
 * Canonical entity lifecycle events for workflow TRIGGER nodes.
 *
 * The registry is now derived from the unified event catalog
 * (`packages/contracts/src/events/**`). Adding a new entity to the catalog
 * automatically exposes its lifecycle verbs here. Keys are camelCase
 * (canonical); legacy PascalCase callers should normalise via
 * `toCamelCase` from `./events/naming.js`.
 *
 * For the same reason workflow-engine's trigger bridge should prefer
 * `getLifecycleRegistry()` directly — the static export below is a
 * snapshot taken at module load for backward compatibility only.
 */

import { getLifecycleRegistry, getEventsForEntity } from './events/registry.js';
import { toCamelCase } from './events/naming.js';

export const ENTITY_EVENT_REGISTRY = getLifecycleRegistry();

/**
 * @param {string} entityType
 * @returns {string[]}
 */
export function getEventsForEntityType(entityType) {
    if (!entityType) return [];
    const canonical = toCamelCase(entityType);
    if (ENTITY_EVENT_REGISTRY[canonical]) return ENTITY_EVENT_REGISTRY[canonical];
    // Fall back to dynamic lookup (custom + lifecycle), trimming to verbs only.
    const events = getEventsForEntity(canonical);
    return events
        .map((name) => name.split('.').slice(-1)[0])
        .filter((v, i, arr) => arr.indexOf(v) === i);
}

/**
 * @param {string} entityType
 * @returns {boolean}
 */
export function isRegistryEntityType(entityType) {
    if (!entityType) return false;
    const canonical = toCamelCase(entityType);
    return Object.prototype.hasOwnProperty.call(ENTITY_EVENT_REGISTRY, canonical);
}
